import { Link } from 'react-router-dom';
import { categories, events } from '@/mocks/events';
import SectionHeading from '@/components/base/SectionHeading';

export default function CategorySection() {
  const countOf = (categoryId: string) => events.filter((item) => item.categoryId === categoryId).length;

  return (
    <section className="py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="主题分类"
          title="按话题方向逛校园"
          desc="从食堂到选课，从宿舍到毕业季。挑一个你感兴趣的方向，看看同校同学们都在经历什么。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/events?cat=${cat.id}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-11 w-11 items-center justify-center rounded-md ${cat.chip}`}>
                  <i className={`${cat.icon} text-xl leading-none`} aria-hidden="true"></i>
                </span>
                <span className="text-xs text-foreground-400">收录 {countOf(cat.id)} 起</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                {cat.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                进入分类
                <i
                  className="ri-arrow-right-line text-base leading-none transition-transform group-hover:translate-x-1"
                  aria-hidden="true"
                ></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}